import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _4gPlusMobiledataIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"4g_plus_mobiledata"} ref={ref}/>
});

_4gPlusMobiledataIcon.displayName = "_4gPlusMobiledataIcon";
